/**
 * Servidores MCP (Model Context Protocol) ligados ao agente de IA.
 *
 * Diferente de uma integração de API, onde cada endpoint é cadastrado, aqui só
 * a URL é cadastrada: o servidor descreve as próprias ferramentas e o agente as
 * descobre em tempo de execução.
 */

export type AuthTipoMcp = "none" | "bearer" | "header";

export const authTiposMcp: { id: AuthTipoMcp; label: string }[] = [
  { id: "none", label: "Sem autenticação" },
  { id: "bearer", label: "Bearer token" },
  { id: "header", label: "Header personalizado" },
];

export interface McpServidor {
  id?: number;
  nome: string;
  descricao?: string | null;
  /** URL do endpoint MCP. Só HTTP remoto: stdio não é suportado. */
  url: string;

  auth_tipo: AuthTipoMcp;
  /** Nome do header quando `auth_tipo === "header"` (ex.: X-API-Key). */
  auth_header?: string | null;
  /**
   * Só na escrita. O GET nunca devolve a credencial — devolve `tem_credencial`.
   * Ausente num PUT significa "mantém a credencial atual".
   */
  auth_valor?: string | null;
  /** Indica que existe credencial gravada, sem expor o valor. */
  tem_credencial?: boolean;

  /** Allowlist de nomes de ferramentas. Vazio = todas as que o servidor expõe. */
  ferramentas_permitidas: string[];

  timeout_ms: number;
  ativo: boolean;

  organizacao_id?: number | null;
  data_criacao?: string;
  data_ultima_atualizacao?: string;
  data_exclusao?: string | null;
}

/** Resposta de `POST /mcp_servidor/:id/testar`. */
export interface TesteConexaoMcp {
  ok: boolean;
  /** Nomes das ferramentas anunciadas pelo servidor. */
  ferramentas: { nome: string; descricao?: string }[];
  erro?: string;
}

export const TIMEOUT_MCP_PADRAO = 30000;
